import { usePost, useAuth } from "@onefront/react-sdk";
import { generateHeaders } from "../../../utils/generate-headers";
import { SecurityEnvData } from "../../../@types/dtos/intermediaries/SecurityEnvData";

interface IParamsFetch {
    url?: string;
    params?: any;
    headers?: any;
    data: SecurityEnvData;
}

interface IusePostSecurityEnvironments {
    (tenantItemId?: string, taxId?: string, siteCode?: string, params?: any | object, lazy?: boolean): {
        data?: null;
        loading?: boolean;
        fetch: (fetchConfig: IParamsFetch) => Promise<any>;
        error: boolean;
    };
}

export const usePostSecurityEnvironments: IusePostSecurityEnvironments = (
    tenantItemId,
    taxId,
    siteCode,
    params = {},
    lazy = true
) => {
    return usePost(
        `rnd:core:intermediary-registry-write:api://v1/${tenantItemId}/intermediary/${taxId}/security-environment/${siteCode}`,
        {},
        {
            params: {
                ...params
            },
            headers: generateHeaders(useAuth(), tenantItemId, tenantItemId),
            lazy
        }
    );
};
